<style>
.glow-on-hover {
  border: none;
  outline: none;
  color: #fff;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 5px;
}

.glow-on-hover:before {
  content: "";
  background: linear-gradient(45deg,
      #ff0000,
      #ff7300,
      #fffb00,
      #48ff00,
      #00ffd5,
      #002bff,
      #7a00ff,
      #ff00c8,
      #ff0000);
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing 20s linear infinite;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  border-radius: 5px;
}

.glow-on-hover:active {
  color: #000;
}

.glow-on-hover:active:after {
  background: transparent;
}

.glow-on-hover:hover:before {
  opacity: 1;
}

.glow-on-hover:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #2a2828;
  left: 0;
  top: 0;
  border-radius: 5px;
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }

  50% {
    background-position: 400% 0;
  }

  100% {
    background-position: 0 0;
  }
}

.del_button {
  display: block;
  border-radius: 7px;
  width: 200px;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  font-family: sans-serif;
  text-decoration: none;
  color: #ff003b;
  border: 2px solid #ff003b;
  letter-spacing: 2px;
  text-align: center;
  position: relative;
  transition: all .35s;
}

.del_button span {
  position: relative;
  z-index: 2;
}

.del_button:after {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background: #ff003b;
  transition: all .35s;
}

.del_button:hover {
  color: #fff;
}

.del_button:hover:after {
  width: 100%;
}

.submit-btn {
  min-width: 60px;
  min-height: 60px;
  display: inline-flex;
  font-family: 'Nunito', sans-serif;
  font-size: 22px;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 1.3px;
  font-weight: 700;
  color: #313133;
  background: #599f4d;
  background: linear-gradient(90deg, #599f4d 0%, #599f4d 100%);
  border: none;
  border-radius: 60px;
  transition: all 0.4s ease-in-out 0s;
  cursor: pointer;
  outline: none;
  position: relative;
  padding: 10px;
}

.submit-btn::before {
  content: '';
  border-radius: 1000px;
  min-width: calc(60px + 12px);
  min-height: calc(60px + 12px);
  border: 4px solid rgba(43, 122, 44, 0.64);
  box-shadow: 0 0 60px rgba(43, 122, 44, 0.64);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all .3s ease-in-out 0s;
}

.submit-btn:hover,
.submit-btn:focus {
  color: #313133;
  transform: translateY(-6px);
}

.submit-btn:hover::before,
.submit-btn:focus::before {
  opacity: 1;
}

.submit-btn::after {
  content: '';
  width: 30px;
  height: 30px;
  border-radius: 100%;
  border: 6px solid #599f4d;
  position: absolute;
  z-index: -1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ring 1.5s infinite;
}

.submit-btn:hover::after,
.submit-btn:focus::after {
  animation: none;
  display: none;
}

@keyframes ring {
  0% {
    width: 30px;
    height: 30px;
    opacity: 1;
  }

  100% {
    width: 300px;
    height: 300px;
    opacity: 0;
  }
}
</style>
<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="element-box row col-12" style="float: center;">
          <div class="col-5" style="min-width: 0; width: 310px;">
            <div>
              <h5 class="form-header">Impresión de Habladores</h5>
              <span style="color: grey; font-size: 15px;">Ofertas, Promociones, Productos Nuevos</span>
              <br><br>
              <div class="row">
                <div class="col-12">
                  <TiendaSelectComponent :current="current" :disabled="precios_imprimir.length > 0" />
                </div>
                <div class="col-12" v-if="current.tienda">
                  <ProductoSelectComponentV2 :current="current" @onChangeProducto="seleccionProducto">
                  </ProductoSelectComponentV2>
                  <small v-if="current.errors && current.errors.proveedor" class="form-text text-danger">{{
                    current.errors.proveedor }}</small>
                  <div class="row col-4" title="Si desea imprimir producto ofertado, debe activar el interruptor">
                    <b>¿Es producto Ofertado?</b>
                    <br>
                    <label class="switch" id="ofertaSwitch" @change="OfertaSelector()">
                      <input class="text-center" type="checkbox" v-model="switchState" true-value="1" false-value="0"
                        :disabled="precios_imprimir.length > 0" />
                      <span class="slider-button"></span>
                    </label>
                  </div>
                </div>
                <hr />
              </div>
              <div class="form-buttons-w row">
                <button @click="agregarProducto()" class="btn btn-sm" :disabled="!validacion"
                  style="background-color: #599f4d; color: white;">
                  <span>Agregar Producto &nbsp; <i class="fas fa-plus"></i></span>
                </button>
                <button class="btn btn-md btn-danger" @click="refreshDataDefault">
                  Limpiar Todo &nbsp; <i class="fas fa-sync"></i>
                </button>
                <div class="col-1"></div>
              </div>
            </div>
          </div>
          <div class="col-1"></div>
          <div class="col-4">
            <div style="background-color: #f2f2f2; width: 90%;">
              <table v-if="current.precios_lista.length != 0" style="
                  min-width: 308px;
                  width: 100%;
                  height: 314px;
                  margin: 0 auto;
                  background-color: white;
                  border: 1px solid gray;
                ">
                <tbody>
                  <br><br><br><br>
                  <tr>
                    <td colspan="" class="text-center">
                      <span style="font-size: 55px; font-weight: bold" v-if="current.precio_1">
                        {{ current.precio_1.unidad_medida.cantidad_unidades }} X
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="" class="text-center">
                      <select style="font-size: 54px; font-weight: bold; text-align: center" v-model="current.precio_1">
                        <option v-for="p_current in current.precios_lista" :key="p_current.id" :value="p_current">
                          Q
                          {{ p_current.precio }}
                        </option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="" class="text-right">
                      <select style="font-size: 16px; text-align: right" v-model="current.precio_2">
                        <option value="">Sin Segundo Precio</option>
                        <option v-for="p_current in current.precios_lista" :key="p_current.id" :value="p_current">
                          1 {{ p_current.unidad_medida.nombre }} x Q {{ p_current.precio }}
                        </option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="" class="text-center">
                      <span style="font-size: 25px; font-weight: bold">{{
                        current.producto.nombre
                        }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="" class="text-center" style="padding: 10px">
                      <input type="text" onkeyup="this.value = this.value.toUpperCase()" v-model="current.texto"
                        style="font-size: 20px; text-align: center" maxlength="45" placeholder="TEXTO ADICIONAL" />
                    </td>
                  </tr>
                  <hr>
                  <tr>
                    <td colspan="" class="text-left row" style="padding: 10px">
                      <div class="col-9">
                        <span>* Promoción válida hasta agotar existencias</span>
                      </div>
                      <div class="col-3">
                        <span style="text-align:right">{{ current.producto.sku }} - {{ current.tienda }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div style="background-color: white; float: right;" v-show="validacion" class="col-1">
                <button class="submit-btn" style="color: white;" @click="agregarProducto()" v-show="validacion"><i
                    class="fas fa-check"></i></button>
              </div>
            </div>
          </div>
        </div>
        <!-- PRE VISUALIZACIÓN DE IMPRESIÓN, REPORTE DE PRODUCTOS A IMPRIMIR -->
        <div class="col-sm-12">
          <div class="element-box">
            <h5>Vista previa de productos a Imprimir</h5>
            <span style="color: darkred; font-size: 16px;" v-if="switchState == '1' && precios_imprimir.length > 0"><i
                class="os-icon os-icon-shopping-cart"></i>
              Producto en Oferta</span>
            <span style="color: darkred; font-size: 16px;" v-if="switchState == '0' && precios_imprimir.length > 0">
              <i class="os-icon os-icon-star"></i>
              Producto Nuevo o de Temporada</span>
            <br><br>
            <div class="row col-12" style="background-color: #f2f2f2;">
              <div class="col-6" v-for="(current_preview, index) in precios_imprimir">
                <div style="background-color: #f2f2f2; width: 104%; padding: 10px 10px">
                  <table v-if="current_preview.precios_lista.length != 0" style="
                      width: 450px;
                      height: 400px;
                      margin: 0 auto;
                      background-color: white;
                    ">
                    <tbody>
                      <tr>
                        <td colspan="" class="text-left">
                          <div class="del_button" style="width: 40px; height: 40px;">
                            <a @click="quitarItem(current_preview)"><span><i class="fas fa-times"></i></span></a>
                          </div>
                          <a href="#" class="btn-flip" data-back="Back" data-front="Front"></a>
                        </td>
                        <td colspan="" class="text-center">
                          <span style="font-size: 30px; font-weight: bold"></span>
                        </td>
                      </tr>
                      <br>
                      <tr>
                        <td colspan="" class="text-center">
                          <span style="font-size: 55px; font-weight: bold" v-if="current_preview.precio_1">
                            {{
                              current_preview.precio_1.unidad_medida.cantidad_unidades
                            }} X
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="" class="text-center">
                          <span style="font-size: 60px; font-weight: bold; text-align: center">Q {{
                            current_preview.precio_1.precio }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="" class="text-right">
                          <span style="font-size: 20px; text-align: right" v-if="current_preview.precio_2">
                            1 {{
                              current_preview.precio_2.unidad_medida.nombre
                            }}
                            x Q {{ current_preview.precio_2.precio }}
                          </span>
                          <span style="font-size: 20px; text-align: right" v-if="!current_preview.precio_2">
                            &nbsp;
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="" class="text-center">
                          <span style="font-size: 25px; font-weight: bold">&nbsp;&nbsp;&nbsp;{{
                            current_preview.producto.nombre
                            }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="" class="text-center" style="padding: 10px ;">
                          <span style="font-size: 20px; text-align: center">{{
                            current_preview.texto
                            }}</span>
                        </td>
                      </tr>
                      <hr>
                      <tr>
                        <td colspan="" class="text-left row" style="padding: 10px">
                          <div class="col-9">
                            <span>* Promoción válida hasta agotar existencias</span>
                          </div>
                          <div class="col-3">
                            <span style="text-align:right">{{ current_preview.producto.sku }} - {{
                              current_preview.tienda }}</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <br>
            <div class="btn-group dropright glow-on-hover">
              <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                <span>Generar Reporte PDF &nbsp; <i class="far fa-file-pdf"></i> &nbsp;</span>
              </button>
              <div class="dropdown-menu">
                <button @click="Imprimir()" class="dropdown-item" :disabled="precios_imprimir.length == 0"
                  title="Impresión Múltiple de Precios">
                  <span>Imprimir Formato x6 &nbsp; <i class="	fa fa-qrcode"></i></span>
                </button>
                <button @click="ImprimirCarta()" class="dropdown-item" type="button"
                  :disabled="precios_imprimir.length != 1"
                  title="Solo puede imprimir un producto a la vez en este Formato">
                  <span>Imprimir Tamaño Carta 1:1 &nbsp; <i class="far fa-file-pdf"></i></span>
                </button>
                <button @click="ImprimirHorizontal()" class="dropdown-item" type="button"
                  :disabled="precios_imprimir.length != 1">
                  <span>Imprimir Formato Horizontal
                    &nbsp;<i class="fas fa-print"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "../../../services/commons/DynamicService";

export default {
  components: {
    ProductoSelectComponentV2,
    TiendaSelectComponent,
  },
  data() {
    return {
      tienda_id: null,
      precio_1: "",
      current: {
        tienda: null,
        producto: {
          sku: null,
        },
        errors: {},
        precios_lista: [],
        precio_1: null,
        precio_2: null,
        texto: null,
      },
      precios_imprimir: [],
      datos: [],
      datos_: [],
      switchState: 0,
    };
  },
  computed: {
    validacion: function () {
      let self = this;
      if (self.current.tienda == null) {
        return false;
      }
      if (self.current.producto.sku == null) {
        return false;
      }
      return true;
    },
  },
  methods: {
    refreshDatos(producto) {
      let self = this;
      DynamicService.getActionList("cat", "productos", "obtener_precio_por_tienda", {
        producto: producto,
      }).then((response) => {
        console.log(response.data, "xxx");
        self.datos_.push(response.data);
      });
    },
    agregarProducto() {
      let self = this;
      if (!self.current.tienda) {
        Notifications.alert.error(
          "Agregar producto",
          "El campo de tienda es obligatorio"
        );
        return;
      }
      if (self.current.precio_1 == null) {
        return;
      }
      // Validación para limitar que se añadan más de 6 productos al listado de impresión.
      if (self.precios_imprimir.length >= 6) {
        Notifications.alert.error(
          "¡Ocurrió un error!",
          "Recuerda que solo se puede agregar un máximo de 6 productos."
        );
        return;
      }
      if (self.tienda_id == null) {
        self.tienda_id = self.current.tienda;
      }

      if (self.tienda_id != self.current.tienda) {
        Notifications.alert.error("Agregar producto", "Debe seleccionar la misma tienda");
        return;
      }
      self.precios_imprimir.push(Object.assign({}, self.current));
      self.current = Object.assign(self.current, {
        producto: {
          sku: null,
        },
        errors: {},
        precios_lista: [],
        precio_1: null,
        precio_2: null,
        texto: null,
      });
      // self.functionAgregar();
    },
    functionAgregar() {
      let self = this;
      let nextIndex = self.datos.length + 1;
      let producto = {};
      producto[`p${nextIndex}`] = self.current.producto.sku;
      self.datos.push(producto);
      self.refreshDatos(self.current.producto.sku);
    },
    Imprimir() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      var reportName = "catalogos/promociones/oferta_colorx6.jrxml&";

      let paramsObject = {
        tienda: self.tienda_id,
        id1: "",
        id2: "",
        id3: "",
        id4: "",
        id5: "",
        id6: "",
        id7: "",
        id8: "",
        id9: "",
        id10: "",
        id11: "",
        id12: "",
        ot1: "",
        ot2: "",
        ot3: "",
        ot4: "",
        ot5: "",
        ot6: "",
        p1: "",
        p2: "",
        p3: "",
        p4: "",
        p5: "",
        p6: "",
        tipo: "",
        txt1: "",
        txt2: "",
        txt3: "",
        txt4: "",
        txt5: "",
        txt6: "",
        oft: self.switchState,
      };

      let index_global = 0;
      self.precios_imprimir.forEach((element, index) => {
        index_global++;
        var _id = element.precio_1.id + "";
        _id = _id.replace(/-/g, "");
        paramsObject["id" + index_global] = _id;
        paramsObject["ot" + (index + 1)] = "B";
        paramsObject["txt" + (index + 1)] = element.texto;

        index_global++;
        if (element.precio_2 != null && element.precio_2 != "") {
          _id = element.precio_2.id + "";
          _id = _id.replace(/-/g, "");
          paramsObject["id" + index_global] = _id;
        } else {
          paramsObject["id" + index_global] = "";
        }
      });

      var query_params = Object.keys(paramsObject)
        .filter(function (key) {
          return paramsObject[key] ? true : false;
        })
        .map(function (key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(paramsObject[key]);
        })
        .join("&");
      var url = baseApiUrl + "/cat/reporte/?report_name=" + reportName + query_params;
      window.open(url);
      self.refreshDataDefault();
      document.documentElement.scrollTop = 0;
      Notifications.toast.success("¡Reporte x6 Generado!", "El documento está listo para Imprimir");
    },
    ImprimirCarta() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      var reportName = "catalogos/promociones/oferta_carta.jrxml&";

      let paramsObject = {
        tienda: self.tienda_id,
        id1: "",
        id2: "",
        ot1: "",
        p1: "",
        oft: self.switchState,
        txt1: "",
      };

      let index_global = 0;
      self.precios_imprimir.forEach((element, index) => {
        index_global++;
        var _id = element.precio_1.id + "";
        _id = _id.replace(/-/g, "");
        paramsObject["id" + index_global] = _id;
        paramsObject["ot" + (index + 1)] = "B";
        paramsObject["txt" + (index + 1)] = element.texto;

        index_global++;
        if (element.precio_2 != null && element.precio_2 != "") {
          _id = element.precio_2.id + "";
          _id = _id.replace(/-/g, "");
          paramsObject["id" + index_global] = _id;
        } else {
          paramsObject["id" + index_global] = "";
        }
      });

      var query_params = Object.keys(paramsObject)
        .filter(function (key) {
          return paramsObject[key] ? true : false;
        })
        .map(function (key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(paramsObject[key]);
        })
        .join("&");
      var url = baseApiUrl + "/cat/reporte/?report_name=" + reportName + query_params;
      window.open(url);
      self.refreshDataDefault();
      document.documentElement.scrollTop = 0;
      Notifications.toast.success("¡Reporte Tamaño Carta Generado!", "El documento está listo para Imprimir");
    },
    refreshDataDefault() {
      let self = this;
      self.datos = [];
      self.datos_ = [];
      self.precios_imprimir = [];
      self.tienda_id = null;
      self.current.tienda = "";
      self.current.producto = "";
      self.current = Object.assign(self.current, {
        producto: {
          sku: null,
        },
        errors: {},
        precios_lista: [],
        precio_1: null,
        precio_2: null,
        texto: null,
      })
    },
    ImprimirHorizontal() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      var reportName = "catalogos/promociones/oferta_horizontal.jrxml&";

      let paramsObject = {
        tienda: self.tienda_id,
        id1: "",
        id2: "",
        ot1: "",
        p1: "",
        oft: self.switchState,
        txt1: "",
      };

      let index_global = 0;
      self.precios_imprimir.forEach((element, index) => {
        index_global++;
        var _id = element.precio_1.id + "";
        _id = _id.replace(/-/g, "");
        paramsObject["id" + index_global] = _id;
        paramsObject["ot" + (index + 1)] = "B";
        paramsObject["txt" + (index + 1)] = element.texto;

        index_global++;
        if (element.precio_2 != null && element.precio_2 != "") {
          _id = element.precio_2.id + "";
          _id = _id.replace(/-/g, "");
          paramsObject["id" + index_global] = _id;
        } else {
          paramsObject["id" + index_global] = "";
        }
      });

      var query_params = Object.keys(paramsObject)
        .filter(function (key) {
          return paramsObject[key] ? true : false;
        })
        .map(function (key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(paramsObject[key]);
        })
        .join("&");
      var url = baseApiUrl + "/cat/reporte/?report_name=" + reportName + query_params;
      window.open(url);
      self.refreshDataDefault();
      document.documentElement.scrollTop = 0;
      Notifications.toast.success("¡Reporte Horizontal Generado!", "El documento está listo para Imprimir");
    },
    refreshDataDefault() {
      let self = this;
      self.datos = [];
      self.datos_ = [];
      self.precios_imprimir = [];
      self.tienda_id = null;
      self.current.tienda = "";
      self.current.producto = "";
      self.current = Object.assign(self.current, {
        producto: {
          sku: null,
        },
        errors: {},
        precios_lista: [],
        precio_1: null,
        precio_2: null,
        texto: null,
      })
    },
    seleccionProducto(producto) {
      let self = this;
      DynamicService.getByIdParams("cat", "productos", producto.sku, {
        tienda: self.current.tienda,
        sku: producto.sku,
      }).then((response) => {
        console.log(response.data);
        self.current.precios_lista = response.data.lista_precios;

        self.current.precio_1 =
          self.current.precios_lista[self.current.precios_lista.length - 1];
        self.current.precio_2 = self.current.precios_lista[0];
      });
    },
    quitarItem(current_preview) {
      let self = this;
      let idxObj = self.precios_imprimir.findIndex((object) => {
        return (
          object.precio_1.id == current_preview.precio_1.id &&
          object.precio_2.id == current_preview.precio_2.id
        );
      });

      self.precios_imprimir.splice(idxObj, 1);
    },
    onChangePrecio1(event) {
      alert("");
    },
    OfertaSelector() {
      let self = this
      if (
        self.switchState == '1'
      ) {
        Notifications.toast.success("", "Se cambió a impresión de Ofertas");
      } else {
        Notifications.toast.success("", "Se cambió a impresión de productos nuevos o de temporada");
      }
    },
  },
};
</script>
